/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatbotWidgetBrands } from '../models/ChatbotWidgetBrands';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ChatbotWidgetService {

    /**
     * list brands
     * Returns a list of brands associated to an account
     * @returns ChatbotWidgetBrands successful
     * @throws ApiError
     */
    public static getInternalApiChatbotChatbotWidgetBrands(): CancelablePromise<ChatbotWidgetBrands> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/chatbot/chatbot_widget/brands',
        });
    }

}